var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartlyClear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    x2: "112.465%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FCD35C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FBBC04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "22.493%",
    x2: "100%",
    y1: "17.395%",
    y2: "115.202%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F1F3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DEDFDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "83.458%",
    x2: "-15.637%",
    y1: "100%",
    y2: "-29.648%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E4E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FCD35C"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M16.02 0c-2.265 2.738-3.62 6.212-3.62 9.992 0 8.837 7.402 16 16.533 16 .172 0 .343-.002.514-.007-3.03 3.662-7.689 6.007-12.914 6.007-9.13 0-16.533-7.163-16.533-16C0 7.322 7.126.262 16.02 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M16.02 0c-2.265 2.738-3.62 6.212-3.62 9.992 0 8.837 7.402 16 16.533 16 .172 0 .343-.002.514-.007-3.03 3.662-7.689 6.007-12.914 6.007-9.13 0-16.533-7.163-16.533-16C0 7.322 7.126.262 16.02 0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 9,
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M14.146 24.622A9.053 9.053 0 0 1 14 23a8.96 8.96 0 0 1 1.078-4.274c2.95 4.375 8.054 7.266 13.855 7.266.172 0 .343-.002.514-.007a16.542 16.542 0 0 1-6.548 4.779 7.502 7.502 0 0 0-8.753-6.142Zm2.065 7.367Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    d: "M23 32a7.5 7.5 0 0 0-15 0c.011-.017 15.004-.012 15 0Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartlyClear);
export default __webpack_public_path__ + "static/media/partly_clear.28680ae9f2b6db1912eb77b95988404a.svg";
export { ForwardRef as ReactComponent };